import type { Selector, State as S } from 'model/State';

export const selectIsArchivedLicense: Selector<unknown> = (state: S) =>
  state.mac.license.isArchivedLicense?.ifSuccess((r) => r);

export const selectDeveloperLicense = (state: S, id: string) =>
  state.mac.license.developerLicense?.[id]?.ifSuccess((r) => r);

export const selectLicenseDetails = (state: S, id: string) =>
  state.mac.license.licenseDetails?.[id]?.ifSuccess((r) => r);

export const selectLicenseDetailsResponse = (state: S, id: string) =>
  state.mac.license.licenseDetails?.[id];
